exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".g-mediaspeed-popper{padding:18px 30px 20px 30px}.g-mediaspeed-popper .el-popover__title{font-size:14px}.g-mediaspeed-slider .el-slider__bar{background:none}.g-mediaspeed-slider .el-slider__stop{width:2px;background:#e0e0e0}.g-mediaspeed-slider .el-slider__runway{background:none;border-bottom:2px solid #e0e0e0}.g-mediaspeed-slider .el-slider__button{background:#0095ff;width:14px;height:14px}.g-mediaspeed-slider .el-slider__marks-text{white-space:nowrap;font-size:12px}", ""]);

// exports
